import model from "./model";
const {
  formField: { pharmacyManagersTable, drugsTable, table, group },
} = model;

export default {
  [pharmacyManagersTable.name]: [
    {
      idx: 1,
      tableName: "pharmacyManagersTable",
      name: "",
      planList: [],
    },
  ],
  [drugsTable.name]: [
    {
      idx: 1,
      tableName: "drugsTable",
    },
  ],
  [table.name]: [],
  [group.name]: "",
};
